module.exports = __webpack_public_path__ + "static/media/au-production.ae1453cc.svg";